import { render, staticRenderFns } from "./blockModal.vue?vue&type=template&id=c238eef8&scoped=true"
import script from "./blockModal.vue?vue&type=script&lang=js"
export * from "./blockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c238eef8",
  null
  
)

export default component.exports